import { render, staticRenderFns } from "./ContractorRegistractionModal.vue?vue&type=template&id=8d1d6620&scoped=true&"
import script from "./ContractorRegistractionModal.vue?vue&type=script&lang=ts&"
export * from "./ContractorRegistractionModal.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8d1d6620",
  null
  
)

export default component.exports